import { get } from "@ember/object"
import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"
import { hash } from "rsvp"

export default class UnitRoute extends Route {
  @service("ember-store")
  store

  model(params) {
    let courseParams = this.paramsFor("course")
    return hash({
      course: get(this, "store").find("course", courseParams.course_id),
      courseCalendar: get(this, "store").find("course-calendar", courseParams.course_id),
      unitId: params.unit_id,
    })
  }
}
